<div class="js-with-4-levels with-4-levels box-content">
  <ul class="second-level">
    <ng-container *ngFor="let secondLevel of node?.children; let i = index">
      <li *ngIf="secondLevel?.children?.length || secondLevel.url">
        <button
          class="js-btn-action btn-action"
          type="button"
          [ngClass]="{ 'is-active': i === 0 }"
          [attr.data-index]="i"
          (mouseenter)="setActiveContainer(i)"
        >
          <nav-label [node]="secondLevel" classContainer="label-second-level"></nav-label>
        </button>
      </li>
    </ng-container>
  </ul>

  <ng-container *ngFor="let secondLevel of node?.children; let i = index">
    <ul class="js-third-level second-to-last-level" [ngClass]="{ 'is-active': i === 0 }" [attr.data-index]="i">
      <ng-container *ngFor="let thirdLevel of secondLevel?.children">
        <li *ngIf="thirdLevel?.children?.length || thirdLevel.url">
          <nav-label [node]="thirdLevel" classContainer="label-second-to-last-level"></nav-label>

          <ul class="last-level">
            <ng-container *ngFor="let lastLevel of thirdLevel?.children">
              <li *ngIf="lastLevel?.children?.length || lastLevel.url">
                <nav-label [node]="lastLevel" classContainer="label"></nav-label>
              </li>
            </ng-container>
          </ul>
        </li>
      </ng-container>
    </ul>
  </ng-container>
</div>
